import { useAppDispatch } from "../../hooks/hooks";
import { useEffect, useState } from "react";
import { pushNotifications } from "../../redux/push-notification/action";
import Map from '../../common/components/map'
import { agentLocationTrackers } from "../../redux/agent-location-tracker/action";
import storePersist from "../../redux/storePersist";
import { getFirebaseToken, messaging } from "../../service/firebase";
import { onMessage } from "firebase/messaging";
import { toast } from "react-toastify";
import { MdOutlineNotStarted } from "react-icons/md";
import { FaRegCircleStop } from "react-icons/fa6";
import { MdOutlineGetApp } from "react-icons/md";
import useWindowDimensions from "../../hooks/useWindowsDimensions";

const AgentTracker = () => {
	const dispatch = useAppDispatch()
	const { height, width } = useWindowDimensions();
	const [isLocation, setIsLocation] = useState<boolean>(false)
	const [location, setLocation] = useState<any>([])
	const [dcmTokenData, setDcmTokenData] = useState<any>([])
	const [payload, setPayload] = useState({ notification: { title: '', body: '' } })
	const DCMTokens = storePersist.get("accessTokenMetadata").current.TokenMetadata.DCMMetaData.DCMTokens
	const userProfileId = storePersist.get("accessTokenMetadata").current.TokenMetadata.UserMetaData.UserProfileId
	useEffect(() => {
		if (DCMTokens.length > 0) {
			const lastDCMToken = DCMTokens[DCMTokens.length - 1];
			setDcmTokenData(lastDCMToken)
		} else {
			const lastDCMToken = DCMTokens[0];
			setDcmTokenData(lastDCMToken)
		}
	}, [DCMTokens])
	const image = require('../../assets/img/delivery.png')
	const captureLocation = () => {
		const deviceDetails = {
			userAgent: navigator.userAgent,
			platform: navigator.platform,
			language: navigator.language,
			appVersion: navigator.appVersion,
		};
		console.log('isLocation :', isLocation)
		console.log(deviceDetails)
		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(
				(position) => {
					const { latitude, longitude } = position.coords;
					dispatch(agentLocationTrackers.create({
						url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/agent-location-tracker`, entity: 'agentLocationTrackers', jsonData: {
							Records: [
								{
									"Context": {},
									"Message": {
										"AgentUserProfileId": userProfileId,
										"Latitude": latitude.toString(),
										"Longitude": longitude.toString(),
									}
								}
							]
						}
					}))

					console.log(`Latitude: ${latitude}, Longitude: ${longitude}`);
					setLocation(
						{
							Latitude: latitude,
							Longitude: longitude
						}

					)
				},
				(error) => {
					switch (error.code) {
						case error.PERMISSION_DENIED:
							console.error("User denied the request for Geolocation.");
							alert("Please enable location services for this app in your browser settings.iOS device (Settings > Privacy > Location Services)");
							break;
						case error.POSITION_UNAVAILABLE:
							console.error("Location information is unavailable.");
							alert("Location information is unavailable.");
							break;
						case error.TIMEOUT:
							console.error("The request to get user location timed out.");
							alert("The request to get user location timed out.");
							break;

					}
				},
				{
					enableHighAccuracy: true,
					maximumAge: 0
				}
			);
			//dispatch(updateAgentLocation({ section, field, payload: { isEdit: false, isVerifyButtonVisible: false, isDeleteButtonVisible: true, isSuccess: true } }));

		}
		else {
			console.error("Geolocation is not supported by this browser.");
			alert("Geolocation is not supported by this browser.");
		}
	};
	const handleGetFirebaseToken = () => {
		getFirebaseToken()
			.then((firebaseToken) => {
				console.log(firebaseToken)
				dispatch(pushNotifications.create({
					url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/identity/platform-security/iam/subscribers`, entity: 'pushNotifications', jsonData: {

						Records: [
							{
								Context: {},
								Message: {
									DCMToken: firebaseToken
								}

							}
						]

					}
				}))
			})
			.catch((err) => console.error('An error occured while retrieving firebase token. ', err))
	}
	const handleStartLocation = () => {
		setIsLocation(true)
		toast.info('Start Trigger(Notification)');
	}
	const handleEndLocation = () => {
		setIsLocation(false)
		toast.info('Stop Trigger(Notification)');
	}
	useEffect(() => {
		if (isLocation) {
			captureLocation()
			// Set up the interval to fetch data every 30 seconds (30000 ms)
			const intervalId = setInterval(captureLocation, 30000);
			return () => clearInterval(intervalId);
		}
	}, [isLocation, Location])

	new Promise((resolve) => onMessage(messaging, (payload: any) => {
		setPayload(payload)
		console.log(payload)
		resolve(payload)
	}))
	return (
		<div className="flex flex-col items-center ">
			{width && width < 720 ?
				<div className='pt-6 grid grid-cols-3 gap-2'>
					<div onClick={() => handleStartLocation()}>
						<label className="text-customBlue text-xs font-medium mb-2">Start</label>

						<MdOutlineNotStarted className=' text-2xl text-cyan-950' />
					</div>
					<div onClick={() => handleEndLocation()}>
						<label className="text-customBlue text-xs font-medium mb-2">Stop</label>

						<FaRegCircleStop className=' text-2xl text-cyan-950' />
					</div>
					<div onClick={() => handleGetFirebaseToken()}>
						<label className="text-customBlue text-xs font-medium mb-2">GetFirebaseToken</label>

						<MdOutlineGetApp className=' text-2xl text-cyan-950' />
					</div>
				</div> : <div className='flex w-full justify-start items-start'>
					<button
						onClick={handleStartLocation}
						type='button'
						className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
					>
						Start Trigger(Notification)
					</button>
					<button
						onClick={handleEndLocation}
						type='button'
						className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
					>
						End Trigger(Notification)
					</button>
					<button
						onClick={handleGetFirebaseToken}
						type='button'
						className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
					>
						GetFirebaseToken
					</button>

				</div>}
			<div className="min-h-[450px] w-full  flex flex-col justify-between bg-gray-50 mb-8 py-5 border border-gray-200">
				<div className="w-full bg-white px-5 text-gray-800">

					<div className="w-full">
						<Map
							lat={location.Latitude}
							lng={location.Longitude}
							icon={image}
							height={'400px'}
							zoom={12}
							showInfoWindow={false}
							isRouteDirection={false}
						/>

					</div>
				</div>



			</div>
			<div className="pb-10">
				<h2>Notification Component</h2>
				<ul>

					<li><strong>Current Location: </strong>
						Lat:{location.Latitude},Lng:{location.Longitude}
					</li>

				</ul>
			</div>
		</div>
	);
};

export default AgentTracker;
